import { Color, Radius, Spacing } from 'zens-storybook'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ApiError, CompanyData, DataWithUpload, Draft, useCompanyMutation, useStore } from 'zens-store'
import { Suspense } from 'react'
import { useRouter, useNumberParams } from 'zens-router'
import { CompanyHeader, CompanyVitalityForm, LayoutHeader } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
    padding: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
  },
})

const CompanyVitality = () => {
  const router = useRouter()
  const { message } = useStore()
  const [{ companyId }] = useNumberParams()
  const mutation = useCompanyMutation()

  const { t } = useTranslation()

  const save = async (draft: Draft<DataWithUpload<CompanyData>>) => {
    try {
      await mutation.update(draft)
      message.add({
        message: t('Company vitality was updated successfully'),
        status: 'success',
      })
    } catch (error) {
      const { message: errorMessage } = error as ApiError
      message.add({
        message: `${t('Company vitality could not be saved')}. ${errorMessage}`,
        status: 'error',
      })
      return
    }

    router.push(`/companies/${companyId}/detail`)
  }

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <CompanyHeader companyId={companyId} breadcrumbItems={[{ title: t('Vitality') }]} />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<CompanyVitalityForm.Skeleton />}>
          <CompanyVitalityForm companyId={companyId} onSave={save} />
        </Suspense>
      </View>
    </View>
  )
}

export default CompanyVitality
